import { TableCustom } from '../../../../../component/table/table-custom/TableCustom';

type Props = {
	data: any[];
	columns: any;
	generalInfo?: any
};

const ListDonThuoc = ({ data, columns, generalInfo }: Props) => {
	return (
		<TableCustom<any>
			className={`overflow-auto spaces h-calc-vh-${generalInfo?.isKhamDoan ? "475" : "590"}`}
			data={data}
			columns={columns}
		/>
	);
};

export default ListDonThuoc;
